import {Box, Card, CardContent, CardHeader, Grid} from '@material-ui/core';
import {ArrowBackRounded, ArrowForwardRounded, FiberManualRecord} from '@material-ui/icons';
import {styled, withStyles} from '@material-ui/styles';
import EmptyMessage from 'components/empty-message';
import {BorderLinearProgress} from 'components/progress/border-linear-progress';
import Text from 'components/text';
import PropTypes from 'prop-types';
import React, {Component} from 'react';

export default class Statistics extends Component {
    static propTypes = {
        statistics: PropTypes.array.isRequired,
    };
    state = {
        page: 0,
        perPage: 4,
    };

    createChangePageHandler(step) {
        return () => {
            this.setState(prev => ({
                ...prev,
                page: prev.page + step
            }));
        };
    }

    groupByNameStatistics(statistics) {
        return statistics.reduce((acc, curr) => {
            const title = curr.name.split(' - ').shift();
            const categoryLabel = curr.name.split(' - ').pop();
            if (!acc.has(title)) acc.set(title, []);
            const currentArray = acc.get(title);
            currentArray.push({
                ...curr,
                label: categoryLabel || title,
            });
            acc.set(title, currentArray);
            return acc;
        }, new Map());
    }
    getChart(statistics) {
        const data = Array.from(this.groupByNameStatistics(statistics));
        const startIndex = this.state.page * this.state.perPage;
        const endIndex = startIndex + this.state.perPage;
        const totalPages = Math.ceil(data.length / this.state.perPage);
        const hasMorePages = this.state.page + 1 < totalPages;
        return (
            <Grid container justifyContent='space-between' spacing={2}>
                {data
                    .slice(startIndex, endIndex)
                    .map(([title, categories]) => (
                        <Grid item xs={12} sm={6} md={3} key={title}>
                            <Box display='flex' flexDirection='column' gridRowGap={16}>
                                <Text variant='h3' bold='bolder' >{title}</Text>
                                <Box display='flex' flexDirection='column' gridRowGap={12}>
                                    {categories.map(category => (
                                        <Box key={category.id} display='flex' flexDirection='column' gridRowGap={8}>
                                            <Text variant='h4'>
                                                {category.label} ({category.yesPercentage}%)
                                            </Text>
                                            <Box display='flex' alignItems='center' gridColumnGap={4}>
                                                <Text variant='h4' bold='bolder' component='span'>{category.yesCount}</Text>
                                                <BorderLinearProgress variant='determinate' value={category.yesPercentage} color='primary' />
                                                <Text variant='h4' bold='bolder' component='span'>{category.noCount}</Text>
                                            </Box>
                                        </Box>
                                    ))}
                                </Box>
                            </Box>
                        </Grid>
                    ))}
                {this.state.page > 0 && (
                    <FloattingButton position='left' onClick={this.createChangePageHandler(-1)}>
                        <ArrowBackRounded fontSize='large' />
                    </FloattingButton>
                )}
                {hasMorePages && (
                    <FloattingButton position='right' onClick={this.createChangePageHandler(1)}>
                        <ArrowForwardRounded fontSize='large' />
                    </FloattingButton>
                )}
            </Grid>
        );
    }

    render() {
        const {statistics} = this.props;
        const empty = statistics.every(({yesCount}) => yesCount === 0);
        return (
            <StyledCard
                elevation={0}
                variant='outlined'
            >
                <CardHeader
                    title={<Text variant='h1' bold='boder'>Estadísticas generales</Text>}
                    disableTypography
                />
                <CardContent>
                    <Card elevation={0} variant='outlined'>
                        <CardHeader
                            title={(
                                <Grid container spacing={4}>
                                    <Grid item>
                                        <Grid container>
                                            <FiberManualRecord color='primary' />
                                            <Text variant='h5'>Cantidad de organizaciones que realizaron el tipo de pedido especificado.</Text>
                                        </Grid>
                                    </Grid>
                                    <Grid item>
                                        <Grid container>
                                            <FiberManualRecord color='disabled' />
                                            <Text variant='h5'>Cantidad de organizaciones que no lo hicieron.</Text>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            )}
                            disableTypography
                        />
                    </Card>
                </CardContent>
                <CardContent>
                    {empty ? <EmptyMessage /> : this.getChart(statistics)}
                </CardContent>
            </StyledCard>
        );
    }
}

const FloattingButton = styled('div')(({theme, ...props}) => ({
    width: theme.spacing(6),
    height: theme.spacing(6),
    borderRadius: '100%',
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.grey[200]}`,
    position: 'absolute',
    left: props.position === 'left' ? 0 : undefined,
    right: props.position === 'right' ? 0 : undefined,
    top: theme.spacing(20),
    transform: `translateX(${props.position === 'left' ? '-' : ''}50%)`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    '&:hover': {
        backgroundColor: theme.palette.grey[200],
    },
}));

const StyledCard = withStyles((theme) => ({
    root: {
        position: 'relative',
        overflow: 'unset',
        paddingLeft: theme.spacing(4),
        paddingRight: theme.spacing(4),
        minHeight: theme.spacing(50),
    },
}))(Card);



// WEBPACK FOOTER //
// ./views/home/supervisor-home/statistics/index.js